<template lang="pug">
  .single-ring(ref="SingleRing")
</template>
<script>
// title: '环图',
// insideTitle: 'm³/h    ',
// outTitle: 'T',
// radius: ['50%', '58%'],
// center: ['40%', '60%'],
// data1Max: 200,
// outTitleSign: '°C',
// labelLineLength: 10,
// outTitleFontSize: 15,
// outTitleRichFontSize: 15,
// outTitleRichlineHeight: 20,
// insideTitleRichFontSize: 15,
// insideNumFontSize: 25,
// insideTitleRichlineHeight: 15
export default {
  name: 'SingleRing',
  props: {
    opts: {
      type: Object,
      required: true
    },
    series: {
      required: false
    }
  },
  watch: {
    series: {
      deep: true,
      handler (val) {
        if (val) {
          this.updateSerise(val)
        }
      }
    }
  },
  computed: {
    options () {
      const SingleRingDefault = {
        title: '环图',
        insideTitle: 'm³/h    ',
        outTitle: 'T',
        radius: ['50%', '58%'],
        center: ['40%', '60%'],
        data1Max: 200,
        outTitleSign: '°C',
        labelLineLength: 10,
        outTitleFontSize: 15,
        outTitleRichFontSize: 15,
        outTitleRichlineHeight: 20,
        insideTitleRichFontSize: 15,
        insideNumFontSize: 25,
        insideTitleRichlineHeight: 15
      }
      const resu = Object.assign(SingleRingDefault, this.opts)
      return resu
    }
  },
  data () {
    return {
      graph: null
    }
  },
  mounted () {
    this.initGraph()
  },
  methods: {
    initGraph () {
      this.graph = this.$echarts.init(this.$refs.SingleRing)
      this.graph.showLoading()
    },
    updateSerise (serise) {
      const that = this
      const option = {
        backgroundColor: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: 'rgba(255, 255, 255, 0)'
            },
            {
              offset: 1,
              color: 'rgba(255, 255, 255, 0)'
            }
          ]
        },
        title: {
          text: that.options.title,
          left: '1%',
          top: '2%',
          textStyle: {
            color: '#000',
            fontWeight: '400'
          }
        },
        toolbox: {
          show: false
        },
        series: {
          type: 'pie',
          center: that.options.center, // ['60%', '68%'],
          radius: that.options.radius, // ['60%', '68%'],
          hoverAnimation: false,
          data: [
            {
              value: '',
              name: 'value',
              itemStyle: {
                normal: {
                  color: '#243d91'
                },
                emphasis: {
                  color: '#243d91'
                }
              },
              label: {
                normal: {
                  formatter: [
                    '{a|' + that.options.outTitle + '          }',
                    '{c}' + that.options.outTitleSign
                  ].join('\n'),
                  textStyle: {
                    color: '#000',
                    fontSize: that.options.outTitleFontSize // 30
                  },
                  rich: {
                    a: {
                      color: '#000',
                      fontSize: that.options.outTitleRichFontSize,
                      lineHeight: that.options.outTitleRichlineHeight
                    }
                  }
                }
              },
              labelLine: {
                normal: {
                  show: false,
                  length: that.options.labelLineLength
                },
                emphasis: {
                  show: false
                }
              }
            },
            {
              value: '', // mainData.value,
              name: 'max-value',
              tooltip: {
                show: false
              },
              itemStyle: {
                normal: {
                  color: '#5c8cd3'
                },
                emphasis: {
                  color: '#5c8cd3'
                }
              },
              label: {
                normal: {
                  show: false
                }
              },
              labelLine: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: false
                }
              }
            },
            {
              value: 'RH',
              name: 'RH',
              tooltip: {
                show: false
              },
              label: {
                normal: {
                  position: 'center',
                  formatter: ['{a|' + that.options.insideTitle + '    }', '{a| }'].join(
                    '\n\n\n\n'
                  ),
                  rich: {
                    a: {
                      color: '#000',
                      fontSize: that.options.insideTitleRichFontSize,
                      lineHeight: that.options.insideTitleRichlineHeight
                    }
                  }
                }
              }
            },
            {
              value: '百分比',
              name: '', // mainData.rh + "%",
              tooltip: {
                show: false
              },
              label: {
                normal: {
                  position: 'center',
                  color: '#000',
                  fontSize: that.options.insideNumFontSize
                }
              }
            }
          ]
        }
      }
      if (that.options.data1Max - serise.data1 < 0) {
        that.options.data1Max = serise.data1
      }
      if (serise.data1 < 0) {
        option.series.data[0].itemStyle.normal.color = '#888'
        option.series.data[0].itemStyle.emphasis.color = '#888'
        option.series.data[0].label.normal.formatter = [
          '{a|' + that.options.outTitle + '          }',
          '-{c}' + that.options.outTitleSign
        ].join('\n')
        // data值
        option.series.data[0].value = Math.abs(serise.data1)
      } else {
        // data值
        option.series.data[0].value = serise.data1
      }
      // 最大值-data
      option.series.data[1].value = that.options.data1Max - serise.data1
      // 中间数值
      option.series.data[3].name = serise.data2
      that.graph.hideLoading()
      that.graph.setOption(option)
      window.addEventListener('resize', function () {
        that.graph.resize()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.single-ring {
  width: 100%;
  height: 100%;
}
</style>
